var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1349 10.5339L11.7444 9.05789C12.1849 8.65381 12.4946 8.12737 12.6339 7.54609C12.7731 6.9648 12.7355 6.35517 12.5259 5.79539L11.8382 3.95939C11.5815 3.27435 11.0733 2.71296 10.4171 2.38966C9.76083 2.06635 9.00601 2.00546 8.30644 2.21939C5.73244 3.00689 3.75394 5.39939 4.36294 8.24114C4.76344 10.1101 5.52919 12.4561 6.98194 14.9529C8.19924 17.0557 9.73066 18.9601 11.5232 20.6004C13.6757 22.5594 16.7507 22.0696 18.7292 20.2254C19.2595 19.7309 19.5814 19.0528 19.629 18.3292C19.6767 17.6057 19.4466 16.8912 18.9857 16.3314L17.7249 14.7999C17.345 14.3381 16.8356 14.0003 16.2623 13.8301C15.689 13.6598 15.0779 13.6648 14.5074 13.8444L12.4254 14.5006C12.3452 14.4181 12.2529 14.3199 12.1509 14.2066C11.7229 13.7331 11.3442 13.2172 11.0207 12.6669C10.706 12.1115 10.4486 11.5255 10.2527 10.9179C10.2108 10.7907 10.1716 10.6627 10.1349 10.5339Z",
    fill: "#B52126"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon-call.4e53e6019367c9c009ff7d49649a68ee.svg";
export { ForwardRef as ReactComponent };